/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.facilities.rooms'},
});

const RoomsItem = () => (
  <RouteLinkItem
    route="midas/settings/facilities/rooms"
    title={messages.title}
  />
);

export default RoomsItem;
